import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '@env/environment';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'hospital', loadChildren: () => import('src/app/hospital/hospital.module').then(m => m.HospitalModule) },
      { path: 'user', loadChildren: () => import('src/app/user/user.module').then(m => m.UserModule) },
      { path: 'transfer', loadChildren: () => import('src/app/transfer/transfer.module').then(m => m.TransferModule) },
      { path: 'wxwork', loadChildren: () => import('src/app/wxwork/wxwork.module').then(m => m.WxworkModule) },
      { path: 'admin', loadChildren: () => import('src/app/admin/admin.module').then(m => m.AdminModule) },

      // { path: '**', redirectTo: 'hospital/dashboard', pathMatch: 'full' }
      { path: '**', redirectTo: 'hospital/passport/login', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
      // Pls refer to https://ng-alain.com/components/reuse-tab
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
